import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { LazyLoadEvent, MessageService } from 'primeng/api';
import { NhanSuService } from '../services/nhan-su.service';

@Component({
  selector: 'app-nhan-su',
  templateUrl: './nhan-su.component.html',
  styleUrls: ['./nhan-su.component.css']
})
export class NhanSuComponent implements OnInit {
  currentIdUserSelected = -1;
  showChangePasswordFlag = false;
  data: any;
  loading = false;
  position = 'top';
  editNhanSuFlag = false;
  addNhanSuFlag = false;
  editFormGroup: FormGroup;
  addFormGroup: FormGroup;
  totalRecords: number;
  pageSize = 10;
  pageNumber = 0;
  constructor(private title: Title, private nhanSuService: NhanSuService,
    private message: MessageService, private router: Router) {
    this.totalRecords = 0;

    this.addFormGroup = new FormGroup({
      hoVaTen: new FormControl('', [Validators.required, Validators.min(4)]),
      laCongChungVien: new FormControl(false),
      username: new FormControl(''),
      toanquyen: new FormControl(false),
      password: new FormControl('', [Validators.required, Validators.minLength(1)])
    });
    this.editFormGroup = new FormGroup({
      id: new FormControl(0, Validators.required),
      hoVaTen: new FormControl('', [Validators.required, Validators.min(4)]),
      laCongChungVien: new FormControl(false),
      username: new FormControl(''),
      toanquyen: new FormControl(false),
      tinhtrang: new FormControl(1),
      password: new FormControl('')
    });
  }

  ngOnInit(): void {
    this.title.setTitle("Quản lý thông tin nhân sự");

    this.getAllNhanSu();
  }

  showChangePassword(id: number) {
    this.currentIdUserSelected = id;
    this.showChangePasswordFlag = true;
  }

  hideChangePassword(event: any) {
    this.showChangePasswordFlag = false;
  }

  pageFunction(event: any) {

  }

  getAllNhanSu() {
    this.loading = true;
    // Count
    this.nhanSuService.count().subscribe(
      (resp: any) => {
        if (resp != undefined) {
          this.totalRecords = resp;
          console.log(this.totalRecords);
          console.log(this.pageNumber);
          let searhValue = '';
          this.nhanSuService.findNhanSu(searhValue, this.pageSize, this.pageNumber).subscribe(
            (res: any) => {
              this.data = res;
              this.loading = false;
            }
          );
        }
      }
    );
  }

  getNhanSu(event: LazyLoadEvent) {
    this.loading = true;
    //event.rows

    if (event.rows != null) {
      this.pageSize = event.rows;
    }
    else {
      this.pageSize = 10;
    }
    this.nhanSuService.count().subscribe(
      (resp: any) => {
        if (resp != undefined) {
          this.totalRecords = resp;
          let searhValue = '';
          let pageCurrent = 0;
          if (event.first != null && event.first != undefined) {
            pageCurrent = event.first / this.pageSize;
          }
          else {
            pageCurrent = 0;
          }
          this.nhanSuService.findNhanSu(searhValue, this.pageSize, pageCurrent).subscribe(
            (res: any) => {
              this.data = res;
              this.loading = false;
            }
          );
        }
      }
    );
  }

  showAddNhanSu() {
    this.addFormGroup.reset();
    this.addNhanSuFlag = true;
  }

  addNhanSu() {
    if (this.addFormGroup.valid) {
      this.addNhanSuFlag = !this.addNhanSuFlag;
      let quyen = this.addFormGroup.controls.toanquyen.value;
      if (quyen == null || quyen == undefined) {
        quyen = 0;
      }
      const dataPost = {
        hovaten: this.addFormGroup.controls.hoVaTen.value,
        lacongchungvien: (this.addFormGroup.controls.laCongChungVien.value ? 1 : 0),
        username: this.addFormGroup.controls.username.value,
        password: this.addFormGroup.controls.password.value,
        quyen: quyen,
        tinhtrang: 1
      };
      this.nhanSuService.add(dataPost).subscribe(
        (resp: any) => {
          if (resp.id != undefined) {
            this.message.add({ severity: 'success', summary: 'Thông báo', detail: 'Đã thêm thành công!' });
            this.getAllNhanSu();
          }
          else {
            this.message.add({ severity: 'error', summary: 'Thông báo', detail: 'Có lỗi khi thêm!' });
          }
        }
      );
    } else {
      this.message.add({ severity: 'error', summary: 'Thông báo', detail: 'Bạn chưa nhập đủ thông tin!' });
    }
  }

  showEditNhanSu(id: number) {
    this.editNhanSuFlag = true;
    this.nhanSuService.getNhanSuById(id).subscribe(
      (res: any) => {
        this.editFormGroup.controls.id.setValue(id);
        this.editFormGroup.controls.hoVaTen.setValue(res.hovaten);
        this.editFormGroup.controls.laCongChungVien.setValue(res.lacongchungvien);
        this.editFormGroup.controls.username.setValue(res.username);
        this.editFormGroup.controls.toanquyen.setValue(+res.quyen > 0 ? true : false);
        this.editFormGroup.controls.tinhtrang.setValue(res.tinhtrang);
        this.editFormGroup.controls.password.setValue(res.password);
      }
    );
  }

  editNhanSu() {
    if (this.editFormGroup.valid) {
      this.editNhanSuFlag = !this.editNhanSuFlag;
      let quyen = this.editFormGroup.controls.toanquyen.value;
      if (quyen == null || quyen == undefined) {
        quyen = 0;
      }
      else {
        if (quyen == false) {
          quyen = 0;
        }
        else {
          quyen = 1;
        }
      }
      this.nhanSuService.update(this.editFormGroup.controls.id.value,
        this.editFormGroup.controls.hoVaTen.value, (this.editFormGroup.controls.laCongChungVien.value ? 1 : 0),
        this.editFormGroup.controls.username.value, quyen,
        +this.editFormGroup.controls.tinhtrang.value, this.editFormGroup.controls.password.value).subscribe(
          (res: any) => {
            if (res == null) {
              this.message.add({ severity: 'success', summary: 'Thông báo', detail: 'Đã cập nhật thành công!' });
              this.getAllNhanSu();
            } else {
              this.message.add({ severity: 'error', summary: 'Thông báo', detail: 'Có lỗi khi cập nhật!' });
            }
          }
        );
    }
    else {
      this.message.add({ severity: 'error', summary: 'Thông báo', detail: 'Bạn chưa nhập đủ thông tin!' });
    }
  }

  delete(id: number) {
    var _al = confirm('Bạn muốn xóa bản ghi này?');
    if (_al == true) {
      this.nhanSuService.delete(id).subscribe(
        (resp: any) => {
          this.getAllNhanSu();
        }
      );
    }
  }

  homeUrlNav() {
    this.router.navigate(['/home']);
  }
}
export interface NhanVien {
  id: number;
  tenNhanVien: string;
  laCongChungVien: number;
}